export default "<app-sidebar></app-sidebar>\n<div class=\"page-wrapper\">\n    <app-topbar></app-topbar>\n    <router-outlet></router-outlet>\n</div>";